<template>
  <component
    :is="tag"
    :class="[
      'btn',
      `btn-${variant}`,
      size ? `btn-${size}` : '',
      block ? 'btn-block' : '',
      pill ? 'rounded-pill' : '',
      pressed ? 'active' : '',
      disabled ? 'disabled' : ''
    ]"
    :disabled="disabled"
    :href="href"
    :type="type"
    :aria-disabled="disabled ? 'true' : null"
    :aria-pressed="pressed ? 'true' : null"
    :tabindex="disabled ? '-1' : null"
    @click="onClick"
    @keydown="onKey"
  >
    <slot />
  </component>
</template>

<script>

const CODE_ENTER = 13
const CODE_SPACE = 32

export default {
  name: 'BButton',
  props: {
    block: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    href: { type: String, default: null },
    pill: { type: Boolean, default: false },
    pressed: { type: Boolean, default: false },
    size: { type: String, default: null },
    tag: { type: String, default: 'button' },
    type: { type: String, default: 'button' },
    variant: { type: String, default: 'secondary' }
  },
  emits: ['click'],
  computed: {
    nonStandardTag() {
      return this.tag !== 'button' && this.tag !== 'a'
    },
    hashLink() {
      return this.tag === 'a' && this.href === '#'
    }
  },
  methods: {
    onClick(e) {
      if (this.disabled) {
        e.preventDefault()
        e.stopPropagation()
      } else {
        this.$emit('click', e)
      }
    },
    onKey(e) {
      // When the link is a `href="#"` or a non-standard tag (has `role="button"`),
      // we add a keydown handlers for CODE_SPACE/CODE_ENTER
      if (this.disabled || !(this.nonStandardTag || this.hashLink)) {
        return
      }
      const { keyCode } = e
      // Add CODE_SPACE handler for `href="#"` and CODE_ENTER handler for non-standard tags
      if (keyCode === CODE_SPACE || (keyCode === CODE_ENTER && this.nonStandardTag)) {
        const target = e.currentTarget || e.target
        e.preventDefault()
        e.stopImmediatePropagation()
        target.click()
      }
    }
  }
}
</script>
